module.exports = __webpack_public_path__ + "img/map.88c5dfd3.png";